import { render } from "./ButtonControl.vue?vue&type=template&id=4a0fc65a&scoped=true"
import script from "./ButtonControl.vue?vue&type=script&lang=js"
export * from "./ButtonControl.vue?vue&type=script&lang=js"

import "./ButtonControl.vue?vue&type=style&index=0&id=4a0fc65a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0fc65a"]])

export default __exports__